module.exports = __webpack_public_path__ + "img/orbeas_rogue_logo.e538570d.svg";